import { AnalyticsBrowser, Plugin } from '@segment/analytics-next';

function getCookie(name: string): string | undefined {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : undefined;
}

const fbCookiePlugin: Plugin = {
  name: 'Facebook Cookie Enrichment',
  type: 'enrichment',
  version: '1.0.0',
  isLoaded: () => true,
  load: () => Promise.resolve(),
  track: (ctx) => {
    const fbp = getCookie('_fbp');
    const fbc = getCookie('_fbc');
    if (fbp) ctx.updateEvent('properties.fbp', fbp);
    if (fbc) ctx.updateEvent('properties.fbc', fbc);
    return ctx;
  },
  page: (ctx) => {
    const fbp = getCookie('_fbp');
    const fbc = getCookie('_fbc');
    if (fbp) ctx.updateEvent('properties.fbp', fbp);
    if (fbc) ctx.updateEvent('properties.fbc', fbc);
    return ctx;
  },
  identify: (ctx) => ctx,
};

export const analytics = AnalyticsBrowser.load(
  {
    writeKey: SEGMENT_WRITE_KEY,
    cdnURL: 'https://sapi.quashed.co.nz/cdn',
  },
  {
    integrations: {
      'Segment.io': {
        apiHost: 'sapi.quashed.co.nz/v1',
        protocol: 'https',
      },
    },
  },
);

analytics.then(([a]) => {
  a.register(fbCookiePlugin);
});
